<template>
  <div class="count-down-wrapper">
    <div class="content-row" style="margin-top: 12px;">
      <span>已募資 {{ funding_percent }}%</span>
      <span class="float-r">
        報名人數 {{ info.enrolled_user_count }} / {{ info.funding_target_enrolled_amount }}人
      </span>
    </div>
    <div class="content-row">
      <div class="progress-bar">
        <span :style="{ width: progressbar_width + '%' }"></span>
      </div>
    </div>
    <div class="content-row">
      <span>募資優惠倒數</span>
      <span class="float-r">
        <span class="em">{{ dd || '0' }}</span>
        <span>天</span>
        <span class="em">{{ hh || '0' }}</span>
        <span>時</span>
        <span class="em">{{ mm || '0' }}</span>
        <span>分</span>
        <span class="em">{{ ss || '0' }}</span>
        <span>秒</span>
      </span>
    </div>
  </div>
</template>

<script>
let timer
export default {
  name: 'AppCountDown',
  props: ['info'],
  computed: {
    progressbar_width () {
      return this.funding_percent > 100 ? 100 : this.funding_percent;
    },
    funding_percent() {
      if (this.info.funding_target_enrolled_amount) {
        let target = parseInt(this.info.funding_target_enrolled_amount)
        let current = parseInt(this.info.enrolled_user_count)
        let result = Math.round(current/target*100)
        return result;
      } else {
        return 0
      }
    }
  },
  data() {
    return {
      dd: 0,
      hh: 0,
      mm: 0,
      ss: 0
    }
  },
  methods: {
    fresh() {
      let now = new Date().getTime()
      let end_at =  new Date(this.info.funding_end_at).getTime()
      let leftsecond = parseInt((end_at - now)/1000)
      if (leftsecond <= 0){
        clearInterval(timer)
      } else {
        this.dd = parseInt(leftsecond/3600/24);
        this.hh = parseInt((leftsecond/3600)%24);
        this.mm = parseInt((leftsecond/60)%60);
        this.ss = parseInt(leftsecond%60);
      }
    }
  },
  created() {
    timer = setInterval(this.fresh, 1000)
  },
  destory() {
    clearInterval(timer);
  }
}
</script>

<style scoped lang="scss">

</style>
